// extracted by extract-css-chunks-webpack-plugin
module.exports = {"news_box":"news_box-Y5AucqEk clearfix","box_r":"box_r-2_wYxW9U","d_box":"d_box-1W2187Br"};